import { useEffect, useState } from "react";
import { Menu, X, ArrowRight } from "lucide-react";
import { NAV_LINKS } from "../../data/content";

const scrollTo = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => {
    scrollTo(id);
    setOpen(false);
  };

  return (
    <header
      data-testid="site-navbar"
      className={`fixed top-0 w-full z-50 transition-all duration-300 border-b ${
        scrolled ? "bg-white/85 backdrop-blur-xl border-slate-200" : "bg-white/0 border-transparent"
      }`}
    >
      <nav className="max-w-[1440px] mx-auto px-6 lg:px-12 h-20 flex items-center justify-between">
        <button data-testid="nav-home" onClick={() => go("home")} className="flex items-center gap-3">
          <img src="/assets/logo.png" alt="TechnoVeda Solutions logo" className="h-11 w-11 object-contain" />
          <span className="font-display font-extrabold text-lg tracking-tight text-slate-900 leading-none">
            TechnoVeda
          </span>
        </button>

        <div className="hidden lg:flex items-center gap-9">
          {NAV_LINKS.map((l) => (
            <button
              key={l.id}
              data-testid={l.testid}
              onClick={() => go(l.id)}
              className="text-sm font-medium text-slate-600 hover:text-[#1E4D8B] transition-colors"
            >
              {l.label}
            </button>
          ))}
          <button
            data-testid="nav-cta"
            onClick={() => go("contact")}
            className="group inline-flex items-center gap-2 bg-[#1E4D8B] text-white hover:bg-[#153a6b] font-medium px-6 py-3 text-sm transition-colors"
          >
            Contact Us
            <ArrowRight className="w-4 h-4 group-hover:translate-x-0.5 transition-transform" />
          </button>
        </div>

        <button
          data-testid="nav-mobile-toggle"
          className="lg:hidden text-slate-900"
          onClick={() => setOpen(!open)}
          aria-label="Toggle menu"
        >
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </nav>

      {open && (
        <div data-testid="nav-mobile-menu" className="lg:hidden bg-white border-t border-slate-200 px-6 py-6 flex flex-col gap-1">
          {NAV_LINKS.map((l) => (
            <button
              key={l.id}
              onClick={() => go(l.id)}
              className="text-left text-slate-700 hover:text-[#1E4D8B] transition-colors py-3 border-b border-slate-100 font-medium"
            >
              {l.label}
            </button>
          ))}
          <button
            onClick={() => go("contact")}
            className="bg-[#1E4D8B] text-white font-medium px-6 py-3 text-sm mt-4"
          >
            Contact Us
          </button>
        </div>
      )}
    </header>
  );
};
